import { LoadingButton } from '@mui/lab';
import { Chip, Grid, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCreateListDataMutation, useGetDataQuery } from '../../api/apiSlice';
import Screen from '../../components/fragments/Screen';
import errorSnackbar from '../../utils/errorSnackbar';

export default function MinistryRouteScreen() {
    const { id } = useParams();
    const { state: routeState } = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const { data: ministryData, isFetching } = useGetDataQuery(
        { list: `departments/${id}` },
        { refetchOnMountOrArgChange: true }
    );
    const [requestJoinMinistry, { isLoading }] = useCreateListDataMutation();

    const ministry = ministryData?.data;
    const { name, notes } = ministry || routeState || {};
    const { status } = ministry?.membership || {};
    const requested = status === 'requested';
    const approved = status === 'approved';

    return (
        <Screen title="Ministry">
            <Grid sx={{ mb: 4 }} item xs={12}>
                {!approved && (
                    <Chip
                        size="small"
                        color="primary"
                        variant="outlined"
                        label={status || 'not joined'}
                    />
                )}
                {approved && (
                    <Chip
                        size="small"
                        color="primary"
                        variant="outlined"
                        label={'member'}
                    />
                )}
                <Typography className="fw-bold text-uppercase mt-3 mb-2">
                    {name}
                </Typography>
                <Typography>
                    <span
                        className="my-3"
                        dangerouslySetInnerHTML={{
                            __html: notes || ministry?.notes,
                        }}
                    ></span>
                </Typography>
                <div
                    className="w-100"
                    style={{
                        padding: 16,
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                    }}
                >
                    {!approved ? (
                        <LoadingButton
                            fullWidth
                            loading={isLoading}
                            variant={requested ? 'outlined' : 'contained'}
                            onClick={async () => {
                                const { data, error } =
                                    await requestJoinMinistry({
                                        list: `departments`,
                                        body: { department: id },
                                    });

                                errorSnackbar(error, enqueueSnackbar);

                                if (data) {
                                    enqueueSnackbar('Request successful');
                                }
                            }}
                        >
                            {requested ? 'Cancel Request' : 'Request to join'}
                        </LoadingButton>
                    ) : (
                        <LoadingButton
                            fullWidth
                            variant="contained"
                            loading={isFetching || isLoading}
                            onClick={() => navigate('/msg')}
                        >
                            Message Church
                        </LoadingButton>
                    )}
                </div>
            </Grid>
        </Screen>
    );
}
